/* unplugin-vue-components disabled */import { render } from "./HomeNews.vue?vue&type=template&id=c7deb5c4&scoped=true"
import script from "./HomeNews.vue?vue&type=script&lang=js"
export * from "./HomeNews.vue?vue&type=script&lang=js"

import "./HomeNews.vue?vue&type=style&index=0&id=c7deb5c4&lang=scss&scoped=true"
import "./HomeNews.vue?vue&type=style&index=1&id=c7deb5c4&scoped=true&lang=scss"

import exportComponent from "/root/.jenkins/workspace/高保障-门户湖南中医药大学-前端页面-saas/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-c7deb5c4"]])

export default __exports__